/**
 * Builds the optimistic local event for an answer to a pending question in the shape that
 * matches the author. Both shapes carry `questionSeq` + `answer`; `STAFF_ANSWER` adds `staffId`.
 */
export function buildChatAnswerEvent(params) {
    const { author, chatId, seq, questionSeq, answer } = params;
    if (author.type === 'STAFF') {
        return {
            chatId,
            seq,
            type: 'STAFF_ANSWER',
            timestamp: Date.now(),
            questionSeq,
            staffId: author.staffId,
            answer,
        };
    }
    return {
        chatId,
        seq,
        type: 'PATIENT_ANSWER',
        timestamp: Date.now(),
        questionSeq,
        answer,
    };
}
//# sourceMappingURL=buildChatAnswerEvent.js.map